import AsyncStorage from '@react-native-async-storage/async-storage';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import api from '@/services/api';
import { Region } from '@/types/discovery';

type RegionState = {
  region: Region;
  /** Já leu o storage — evita piscar "Brasil" antes de saber a cidade salva. */
  isHydrated: boolean;
  setRegion: (region: Region) => void;
  setHydrated: () => void;
};

/**
 * Região da descoberta. Vive no device (funciona deslogado e na web) e, quando
 * há cliente logado, é espelhada na conta para seguir entre dispositivos.
 */
export const useRegionStore = create<RegionState>()(
  persist(
    (set) => ({
      region: { uf: null, city: null },
      isHydrated: false,
      setRegion: (region) => {
        set({ region });

        // Espelha na conta. Deslogado ou guest, a chamada falha e o device manda.
        void api
          .patch('/client/me/region', { state: region.uf, city: region.city })
          .catch(() => undefined);
      },
      setHydrated: () => set({ isHydrated: true }),
    }),
    {
      name: 'discovery-region',
      storage: createJSONStorage(() => AsyncStorage),
      partialize: (state) => ({ region: state.region }),
      onRehydrateStorage: () => (state) => state?.setHydrated(),
    },
  ),
);
